const TooltipWrapper = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children;

export default TooltipWrapper;
